import config from "../../../shared/config/config";
import axiosAdmin from "../../../shared/utils/axiosAdmin";
import axiosAdminBlob from "../../../shared/utils/axiosAdminBlob";
import {
  ChangeManagerRequestDto,
  ChangeWorkgroupStatusReuqestDto,
  DownloadContentRequestDto,
} from "../../../types/adminWorkgroup";
import { BasicReturnMsg } from "../../../types/common";
import { DocumentListReq, DocumentListResp } from "../../../types/files";
import {
  Workgroup,
  WorkgroupDetailDTO,
  WorkgroupRespDto,
  WorkgroupSearchDto,
} from "../../../types/workgroup";

const GATEWAY_URL = config.servers.gateway.url;

interface AdminWorkgroupApi {
  getWorkgroupList(
    logSearchOptions: WorkgroupSearchDto
  ): Promise<WorkgroupRespDto>;
  changeWorkgroupStatus(
    logSearchOptions: ChangeWorkgroupStatusReuqestDto
  ): Promise<BasicReturnMsg>;
  getWorkgroupDetail(workgroupId: string): Promise<WorkgroupDetailDTO>;
  getContentList(logSearchOptions: DocumentListReq): Promise<DocumentListResp>;
  downloadContent(searchOptions: DownloadContentRequestDto): Promise<any>;
  changeManager(searchOptions: ChangeManagerRequestDto): Promise<Workgroup>;
}

class AdminWorkgroupServerApi implements AdminWorkgroupApi {
  async getWorkgroupList(
    logSearchOptions: WorkgroupSearchDto
  ): Promise<WorkgroupRespDto> {
    const resp = await axiosAdmin.post<WorkgroupRespDto>(
      `${GATEWAY_URL}/wapi/admins/workgroups/paging`,
      logSearchOptions
    );
    return Promise.resolve(resp.data);
  }
  async changeWorkgroupStatus(
    logSearchOptions: ChangeWorkgroupStatusReuqestDto
  ): Promise<BasicReturnMsg> {
    const resp = await axiosAdmin.post<BasicReturnMsg>(
      `${GATEWAY_URL}/wapi/admins/workgroups/status`,
      logSearchOptions
    );
    return Promise.resolve(resp.data);
  }
  async getWorkgroupDetail(workgroupId: string): Promise<WorkgroupDetailDTO> {
    const resp = await axiosAdmin.post<WorkgroupDetailDTO>(
      `${GATEWAY_URL}/wapi/workgroups`,
      { workgroupId: workgroupId }
    );
    return Promise.resolve(resp.data);
  }
  async getContentList(
    logSearchOptions: DocumentListReq
  ): Promise<DocumentListResp> {
    const resp = await axiosAdmin.post<DocumentListResp>(
      `${GATEWAY_URL}/wapi/admins/contents/list`,
      logSearchOptions
    );
    return Promise.resolve(resp.data);
  }
  async downloadContent(
    searchOptions: DownloadContentRequestDto
  ): Promise<any> {
    try {
      const resp = await axiosAdminBlob.get<any>(
        `${GATEWAY_URL}/wapi/admins/contents/download/${searchOptions.syncId}/revisions/${searchOptions.revisionNo}`
      );
      return Promise.resolve({ data: resp.data, headers: resp.headers });
    } catch (error) {
      return Promise.resolve({ error: error });
    }
  }
  async changeManager(
    searchOptions: ChangeManagerRequestDto
  ): Promise<Workgroup> {
    const resp = await axiosAdmin.post<Workgroup>(
      `${GATEWAY_URL}/wapi/admins/workgroups/manager`,
      searchOptions
    );
    return Promise.resolve(resp.data);
  }
}
const adminWorkgroupApi: AdminWorkgroupApi = new AdminWorkgroupServerApi();
export default adminWorkgroupApi;
